import { useAtomValue } from 'jotai';
import { useMemo } from 'react';
import { kpiTemplateAssignmentsListStateJ } from '../../../../services/state/KPI/KPICompaniesStateJ';
import { portcosByIdMapAtomJ } from '../../../../services/state/PortCosStateJ';
import { ICompanyDataModel } from '../../../../data-models/company.data-model';
import { TemplateAssignment } from '../../../../schemas/template-assignment-schema';

export interface IAssignedRowData extends Pick<
  TemplateAssignment,
  'templateUuid' | 'frequency' | 'reminderThreshold' | 'id'
> {
  company: ICompanyDataModel;
}

export function useAssignedCompaniesData() {
  const templates = useAtomValue(kpiTemplateAssignmentsListStateJ);
  const portcos = useAtomValue(portcosByIdMapAtomJ);

  return useMemo(() => {
    return templates?.reduce((acc, t) => {
      const company = portcos.get(t.companyId);
      if (company) {
        acc.push({
          ...t,
          company,
        });
      }
      return acc;
    }, [] as IAssignedRowData[]);
  }, [templates, portcos]);
}
